import styled from "styled-components";

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-self: center;
	padding-bottom: 50px;

	@media screen and (min-width: 768px) {
		gap: 10px;
		margin: 0 auto;
	}
	@media screen and (min-width: 1024px) {
		margin-top: 30px;
	}
`;

export const StyledLink = styled.a`
	text-decoration: none;
	color: inherit;
`;
export const TextArea = styled.textarea`
	width: 100%;
	height: 150px;
	padding: 12px;
	font-size: 16px;
	line-height: 1.5;
`;

export const FormInputContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 8px 0;
	min-width: 300px;

	@media (min-width: 768px) {
		width: 600px;
	}

	@media (min-width: 1024px) {
	}
`;

export const FormCheckboxInput = styled.input`
	appearance: none; /* Remove default styling */
	-webkit-appearance: none; /* Safari */
	-moz-appearance: none; /* Firefox */
	width: 20px;
	height: 20px;
	border: 2px solid #050024ac;
	border-radius: 20px;
	background-color: #fff;
	position: relative;
	outline: none;
	margin-right: 8px;

	&:checked::before {
		content: "";
		position: absolute;
		top: 2px;
		left: 2px;
		width: calc(100% - 4px);
		height: calc(100% - 4px);
		background-color: var(--accent-pink);
		border-radius: 20px;
	}
`;

export const FormInputContacts = styled.input`
	padding: 8px;
	border: none;
	border-bottom: 1px solid var(--darktext);
  border-radius: 0;
	font-size: 16px;
	background-color: transparent;
`;

export const SendButton = styled.button`
  text-align: center;
  border-radius: 50px;
  border: none;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  background-color: var(--bg-pink);
  color: var(--mainlight);
  font-weight: 700;
  font-size: 14px;
  width: 110px;
  margin-top: 10px;
  overflow: hidden;
  position: relative;
  z-index: 0;
  transition: transform 0.2s ease;
  padding: 12px 0;

  &:hover {
    color: var(--mainlight);
    z-index: 1;
    background-color: var(--accent-pink);
    transform: scale(1.04);
    transition: transform 0.2s ease-in-out;
  }

  &:active {
    transform: scale(0.95);
    border: none;
    background-color: var(--maindark);
    color: var(--mainlight);
  }

  /* Pseudo-element for wave effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 300%;
    height: 100%;
    background: var(--bg-pink);
    z-index: -1;
    transform: skewX(60deg);
    transition: transform 0.5s ease;
  }

  /* Hover: Move the wave across */
  &:hover::before {
    transform: translateX(100%) skewX(-30deg);
  }
  `;